'use client'
import React, { FunctionComponent, useMemo } from 'react'
import cn from 'classnames'

import styles from './PageTitle.module.scss'
import { replaceParagraphWithBR } from '@/utils/string'

type PageTitleProps = {
  className?: string
  title: string
}
export const PageTitle: FunctionComponent<PageTitleProps> = React.memo(
  ({ className, title }) => {
    const prepareTitle = useMemo(() => {
      if (!title) return ''
      return replaceParagraphWithBR(title)
    }, [title])

    return (
      <h1
        className={cn(className, styles.title)}
        dangerouslySetInnerHTML={{ __html: prepareTitle }}
      ></h1>
    )
  }
)

PageTitle.displayName = 'PageTitle'
